import { deleteHiddenProperty, saveHiddenProperty } from '@propertypal/shared/src/reducers/hidden-properties';
import { useAppDispatch, AppDispatch } from '@propertypal/shared/src/reducers/store';
import router from 'next/router';
import { useCallback } from 'react';

export const hideProperty =
  (dispatch: AppDispatch, loggedIn: boolean, propertyId?: number) =>
  async (hidden: boolean, mPropertyId: number = 0) => {
    const id = propertyId !== undefined ? propertyId : mPropertyId;

    if (!loggedIn) {
      const sourcePath = `hide-property?update=${id}&sourcePath=${window.location.pathname}`;
      await router.push(`/login?sourcePath=/${encodeURIComponent(sourcePath)}`);

      return false;
    }

    if (hidden) {
      return dispatch(saveHiddenProperty(id));
    }

    return dispatch(deleteHiddenProperty(id, false));
  };

const usePropertyHide = (loggedIn: boolean, propertyId?: number) => {
  const dispatch = useAppDispatch();

  return useCallback(() => {
    return hideProperty(dispatch, loggedIn, propertyId);
  }, [loggedIn]);
};

export default usePropertyHide;
